<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <limitless-card-tabs-view :links="routes">
                <router-view></router-view>
            </limitless-card-tabs-view>
        </div>
    </div>
</template>

<script>
import LimitlessCardTabsView from '@components/Limitless/CardTabsView';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';

export default {
    name: 'SupplierPurchases',
    components: {
        LimitlessCardTabsView,
        LimitlessPageHeader,
    },
    data: () => ({
        routes: [
            { name: 'suppliers.purchases.list', text: 'Beställningar' },
            { name: 'suppliers.purchases.items', text: 'Beställda produkter' },
            { name: 'suppliers.purchases.purchasesuggestion', text: 'Beställningsunderlag' },
        ],
    }),
};
</script>
